<template>
  <div>
    <template>
      <Poptip placement="bottom" width="400" ref="poptipModal">
        <span> {{ text }} </span>
        <template #content>
          <div class="modal_content">
            <div class="unitPrice">
              领用类型：
              <Select
                v-model="requisitiontext"
                style="width: 200px"
                @on-change="Onchange(requisitiontext)"
              >
                <Option v-for="item in List" :value="item.label" :key="item.value">{{
                  item.label
                }}</Option>
              </Select>
            </div>
            <div class="modal_content_btn">
              <Button type="primary" class="modal_content_btn_ok" @click="onModalSubmit"
                >确定</Button
              >
            </div>
          </div>
        </template>
      </Poptip>
    </template>
  </div>
</template>

<script>
export default {
  props: ["text", "item"],
  data() {
    return {
      requisitiontext: "",
      List: [
        { label: "目录外申请", value: 2 },
        { label: "目录内物资", value: 1 },
      ],
    };
  },
  created() {
    this.requisitiontext = this.text
  },
  methods: {
    Onchange(value) {
      const text = this.List.find((item) => item.value === value);
      if (text) {
        this.requisitiontext = text.label;
      }
    },
    async onModalSubmit() {
      let q = {};
      if (!this.requisitiontext) {
        $utils.toast.success("请选择领用类型！");
        return;
      }
      if (this.requisitiontext == "目录外申请") {
        q.receiveState = 2;
      } else {
        q.receiveState = 1;
      }
      q.id = this.item.id;
      let res = await $utils.api.load("/admin/system/inventory", q, "PUT");
      if (res.code == 200) {
        this.$refs.poptipModal.handleClose();
        $utils.toast.success("修改成功！");
        this.$emit("reset");
      }
    },
  },
};
</script>

<style lang="less" scoped>
.modal_content {
  padding: 20px;

  .unitPrice {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 20px;
  }

  .modal_content_btn {
    width: 100%;
    display: flex;
    justify-content: center;
  }
}
</style>
